<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

    <!-- 허가내용 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 허가내용</h5>
      <div class="writeGridContainer">
        <div>
          <div>부문</div>
          <custom-option-selector class="w-full" v-model="form.부문" :options="['통합환경', '대기', '수질', '폐기물', '유해화학물질 영업허가', '직접입력']" :addableOption="true" />
        </div>
        <div>
          <div>허가명</div>
          <p v-if="isPrint" class="print-input">{{ form.허가명 }}</p>
          <ml-input v-else class="w-full" v-model="form.허가명" visible-counter :max="100" />
        </div>
        <div>
          <div>관계법령</div>
          <p v-if="isPrint" class="print-input">{{ form.관계법령 }}</p>
          <enviromental-law-class-selector v-else v-model="form.관계법령" class="w-full" :readonly="board.readonly" multiple/>
        </div>
        <div>
          <div>인허가 취득일자</div>
          <p v-if="isPrint" class="print-input">{{ form.인허가취득일자 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.인허가취득일자" />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      title="변경사항"
      :tableData="[
        { id: '일자', title: '일자', type: 'date', width: '320px' },
        { id: '내용', title: '내용', type: 'textarea', rows: 5, contentStyle: 'height: 120px;' },
        { id: '확인', title: '확인(서명 또는 인)', type: 'sign', width: '250px' },
      ]"
      :mobile="['일자', '내용']"
      v-model="form.변경사항"
      class="mt-28px"
    />

    <!--    파일첨부-->
    <file-upload-module id="fileList" title="허가증" class="w-full mt-28px" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector.vue";
import FileDownloadPost from "@/components/FileDownloadPost.vue";
import EnviromentalLawClassSelector from "@/components/selector/EnviromentalLawClassSelector.vue";
import TableCustom from "@/components/TableCustom.vue";

export default {
  components: {
    TableCustom,
    EnviromentalLawClassSelector,
    FileDownloadPost,
    CustomOptionSelector,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        subInfo: {},

        부문: '',
        허가명: '',
        관계법령: '',
        인허가취득일자: '',

        변경사항: [],
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },

};
</script>
<style lang="scss" scoped>
</style>
